// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../endOfSecond/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var endOfSecond = convertToFP(fn, 1);
export default endOfSecond;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/endOfSecond/index.js
// module id = 866
// module chunks = 0